import { RouteObject } from 'react-router'
import announcementsRoutes from './announcements/routes'
import awardsRoutes from './awards/routes'
import celebrationsRoutes from './celebrations/routes'
import checkInsRoutes from './checkIns/routes'
import incentivesRoutes from './incentives/routes'

const routes: RouteObject[] = [
  ...announcementsRoutes,
  ...awardsRoutes,
  ...celebrationsRoutes,
  ...checkInsRoutes,
  ...incentivesRoutes,
]

export default routes
